<template>
  <div class="aaaaa">
    <!-- 头部部分 -->
    <div class="bbbbb">
      <div ref="search_d">
        <el-row class="row-bg" style="font-size: 14px">
          <el-form :model="queryInfo.condition" class="demo-form-inline" label-width="120px">

            <el-row>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="商家名称">-->
              <!--                  <el-input clearable v-model="queryInfo.condition.supplierName" placeholder="商家名称"></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->

              <el-col :span="6">

                <el-form-item label="客户昵称">
                  <el-input clearable v-model="queryInfo.condition.memberName" placeholder="客户昵称"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="收货人名称">
                  <el-input clearable v-model="queryInfo.condition.recipientName" placeholder="收货人名称"></el-input>
                </el-form-item>

              </el-col>

              <el-col :span="6">
                <el-form-item label="收货人号码">
                  <el-input clearable v-model="queryInfo.condition.recipientPhone" placeholder="收货人号码"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">

                <el-form-item label="订单号">
                  <el-input clearable v-model="queryInfo.condition.orderNumber" placeholder="订单号"></el-input>
                </el-form-item>
              </el-col>

            </el-row>

            <!--            <el-row>-->

            <!--&lt;!&ndash;              <el-col :span="6">&ndash;&gt;-->
            <!--&lt;!&ndash;                <el-form-item label="团长名称">&ndash;&gt;-->
            <!--&lt;!&ndash;                  <el-input clearable v-model="queryInfo.condition.teamName" placeholder="团长名称"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;                </el-form-item>&ndash;&gt;-->
            <!--&lt;!&ndash;              </el-col>&ndash;&gt;-->
            <!--&lt;!&ndash;              <el-col :span="6">&ndash;&gt;-->
            <!--&lt;!&ndash;                <el-form-item label="团长手机号">&ndash;&gt;-->
            <!--&lt;!&ndash;                  <el-input clearable v-model="queryInfo.condition.teamPhone" placeholder="团长手机号"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;                </el-form-item>&ndash;&gt;-->
            <!--&lt;!&ndash;              </el-col>&ndash;&gt;-->
            <!--&lt;!&ndash;              <el-col :span="6">&ndash;&gt;-->
            <!--&lt;!&ndash;                <el-form-item label="提货点">&ndash;&gt;-->
            <!--&lt;!&ndash;                  <el-input clearable v-model="queryInfo.condition.siteName" placeholder="提货点"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;                </el-form-item>&ndash;&gt;-->
            <!--&lt;!&ndash;              </el-col>&ndash;&gt;-->
            <!--            </el-row>-->

            <el-row>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="订单所属">-->
              <!--                  <el-select clearable v-model="queryInfo.condition.goodSourceType" placeholder="订单所属">-->
              <!--                    <el-option label="平台" value="1"></el-option>-->
              <!--                    <el-option label="供应商" value="2"></el-option>-->
              <!--                  </el-select>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->

              <el-col :span="9">

                <el-form-item label="交易时间：" prop="industryType">
                  <el-date-picker
                    @change="change"
                    v-model="valuechange"
                    style="width: 100%"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable
                  />
                </el-form-item>
              </el-col>

              <!--              <el-col :span="8">-->
              <!--                <el-form-item label="订单所属">-->
              <!--                  <el-select v-model="queryInfo.condition.goodSourceType" placeholder="订单所属">-->
              <!--                    <el-option label="平台" value="1"></el-option>-->
              <!--                    <el-option label="供应商" value="2"></el-option>-->
              <!--                  </el-select>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->

              <el-col :span="8">
                <el-form-item label-width="20px">
                  <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
                  <el-button  @click="exportExcel" icon="el-icon-download">导出</el-button>
                  <el-button @click="reset" icon="el-icon-refresh-left">重置</el-button>
                </el-form-item>
              </el-col>

            </el-row>

          </el-form>
        </el-row>
      </div>

      <el-tabs v-model="activeName2" @tab-click="handleClick2" class="search_tab">
        <el-tab-pane label="全部" :name="null"></el-tab-pane>
        <el-tab-pane label="待发货" name="1"></el-tab-pane>
        <el-tab-pane label="已发货" name="2"></el-tab-pane>
        <el-tab-pane label="已完成" name="4"></el-tab-pane>
        <el-tab-pane label="已评价" name="5"></el-tab-pane>
        <el-tab-pane label="售后" name="6"></el-tab-pane>
        <!--        <el-tab-pane label="已退款" name="7"></el-tab-pane>-->
      </el-tabs>

      <!-- 表格部分 -->
      <div>

<!--        <el-button type="primary" @click="printOrderList">批量打印小票</el-button>-->

        <el-table v-loading="loading" border ref="table" :data="tableData" tooltip-effect="dark"
                  class="dft-table_hasbtn"
                  style="width: 100%"
                  :height="height" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

          <!-- <el-table-column label="用户名称" align="center" width="100px" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.memberName }}</template>
  </el-table-column>
  <el-table-column label="用户头像" align="center" width="80px" show-overflow-tooltip>
    <template slot-scope="scope">
                <el-avatar shape="square" :size="50" :src="scope.row.memberLogo"></el-avatar>
              </template>
  </el-table-column> -->
          <!-- <el-table-column label="支付单号" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.payNo }}</template>
            </el-table-column> -->
          <el-table-column label="订单号" width="180px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
          </el-table-column>
          <el-table-column label="下单人" width="120px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column label="下单人电话" width="120px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberPhone }}</template>
          </el-table-column>
          <el-table-column label="商品名称" width="180px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.productNames }}</template>
          </el-table-column>

          <!--          <el-table-column label="核销码" width="180px" align="center" show-overflow-tooltip>-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-image :src="scope.row.verifyCode" style="width: 100px; height: 100px;" v-if="scope.row.verifyCode"-->
          <!--                        :preview-src-list="[scope.row.verifyCode]"></el-image>-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <el-table-column label="订单金额/元" width="100px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
          </el-table-column>
          <el-table-column label="实付金额/元" width="100px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
          </el-table-column>
          <el-table-column label="商品图片" align="center" width="280px" show-overflow-tooltip>
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <!-- 利用slice方法限制显示的图片数量 -->
                <el-image shape="square" v-for="(img, index) in scope.row.imgList.slice(0, 3)" v-bind:key="index"
                          :src="img" style="width: 50px;height: 50px;"></el-image>
                <!-- 如果图片数量超过3张，可以添加额外提示或图标 -->
                <span v-if="scope.row.imgList.length > 3" style="display: flex;align-items: flex-end;color: red;">+{{
                    scope.row.imgList.length - 3
                  }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="供应商编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.supplierCode }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="供应商名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.supplierName }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="站点编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.siteCode }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="所属站点" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.siteName }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="所属团长编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.teamCode }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="所属团长" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.teamName }}</template>
            </el-table-column> -->
          <el-table-column label="订单状态" align="center" width="120px">
            <template slot-scope="scope">
              <el-tag type="" >
                {{
                  scope.row.saleAfterStatus == 0 && scope.row.refundStatus == 3 ? '取消订单' :
                    orderStatusMap[scope.row.orderStatus]
                }}
              </el-tag>

            </template>
          </el-table-column>

          <el-table-column label="订单类型" align="center" width="120px">
            <template v-slot="{row}"  >
              <el-tag type="success" v-if="row.isShopCart == 1"> 购物车订单</el-tag>
              <el-tag type="success" v-if="row.type == 1"> 积分订单</el-tag>
              <el-tag type="success" v-if="row.isShopCart != 1 && row.type != 1 ">   {{getOrderType(row.activityType)}}</el-tag>
            </template>
          </el-table-column>

<!--          <el-table-column label="取货方式" align="center" width="100px">-->
<!--            <template slot-scope="scope">{{-->
<!--                getTypeMap[scope.row.orderType]-->
<!--              }}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="快递公司" width="200px" prop="expressNo" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <!--              row.deliveryType }}-->
              {{ getCourierName(row.deliveryType) }}
            </template>
          </el-table-column>

          <el-table-column label="运单号" width="200px" prop="" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <!--              row.deliveryType }}-->
              {{ row.expressNo ? row.expressNo : '-' }}
            </template>
          </el-table-column>
          <!--          <el-table-column label="供应商名称" width="150" align="center" show-overflow-tooltip>-->
          <!--            <template slot-scope="scope">{{ scope.row.supplierName }}</template>-->
          <!--          </el-table-column>-->

          <el-table-column label="下单时间" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.orderTime }}</template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="showOrderItemInfo(scope.row)" size="small">查看详情</el-button>
              <el-button type="text" style="color: red" v-if="scope.row.orderType==3"
                         size="small">
                <!--                <span v-if="scope.row.printWaybillCount == 0" @click="delivery(scope.row)">预约取件</span>-->
                <!--                <span v-else>预约成功</span>-->

              </el-button>

              <el-button type="text" @click="printOrder(scope.row)"
                         size="small">打印小票
              </el-button>
              <el-button style="color: red" type="text" v-if="[1,2].includes(scope.row.orderStatus)" @click="goDelivery(scope.row)"
                         size="small">发货
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]"
                         :page-size="queryInfo.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog title="修改地址" :visible.sync="addressDialog">
      <el-form :model="setaddress">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="区域" prop="siteName">
              <!-- <el-input
                v-model="setaddress.expAreaDetail"
                placeholder="请输入省市区"
              ></el-input> -->
              <MapComponent ref="selectMap"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货地址" prop="siteName">
              <el-input v-model="setaddress.expressAddress" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="addressDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveaddress" :loading="btnloading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单详情" :visible.sync="dialogOrderItemVisible" class="info_dialog" top="10vh">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订单信息" name="first">
          <div class="info_box">
            <div class="info_status_box">
              <div class="info_status">当前订单状态：{{
                  orderInfo.saleAfterStatus == 0 &&
                  orderInfo.refundStatus == 3 ? '取消订单' : orderStatusMap[orderInfo.orderStatus]
                }}
              </div>
              <div class="info_change_btn">
                <el-button size="mini" @click="openaddress" round>修改地址</el-button>
              </div>
            </div>
            <div class="info_section">
              <div class="info_section_header">买家信息</div>
              <div class="info_section_cnt">
                <el-row :gutter="10">
                  <el-col :span="8">
                    用户头像：
                    <el-avatar shape="square" :size="50" :src="orderInfo.memberLogo"></el-avatar>
                  </el-col>
                  <el-col :span="8">
                    用户名称:<span class="info_section_span">{{ orderInfo.memberName }}</span>
                  </el-col>
                  <!-- <el-col :span="8">
                    用户手机号:<span class="info_section_span">{{ orderInfo.memberPhone }}</span>
                  </el-col> -->
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    收件人名称:<span class="info_section_span">{{ orderInfo.recipientName }}</span>
                  </el-col>
                  <el-col :span="8">
                    收件人手机号码:<span class="info_section_span">{{ orderInfo.recipientPhone }}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="24">
                    收件人地址:<span class="info_section_span">{{
                      orderInfo.expAreaDetail + orderInfo.expressAddress
                    }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="info_section">
              <div class="info_section_header">订单信息</div>
              <div class="info_section_cnt">
                <el-row :gutter="10">
                  <el-col :span="10">
                    订单号:<span class="info_section_span">{{ orderInfo.orderNumber }}</span>
                  </el-col>
                  <el-col :span="7">
                    支付方式:<span class="info_section_span">{{ getPayType(orderInfo.payType) }}</span>
                  </el-col>
                  <el-col :span="7">
                    实际付款:<span class="info_section_span">{{ orderInfo.actualAmount }}元</span>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="10">
                    下单时间:<span class="info_section_span">{{ orderInfo.orderTime }}</span>
                  </el-col>
                  <el-col :span="10">
                    支付时间:<span class="info_section_span">{{ orderInfo.orderTime }}</span>
                  </el-col>
                  <el-col :span="24">
                    订单备注:<span class="info_section_span">{{ orderInfo.remark }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="info_goods_table">
              <el-table :data="orderItemData">
                <el-table-column label="商品图片" width="80" align="center">
                  <template slot-scope="scope">
                    <el-image shape="square" style="width: 50px;height: 50px;" :src="scope.row.listImg"></el-image>
                  </template>
                </el-table-column>
                <el-table-column property="productName" align="center" show-overflow-tooltip label="商品名称"
                                 width="200"></el-table-column>
                <el-table-column property="sellPrice" align="center" label="单价"></el-table-column>
                <el-table-column property="count" align="center" label="数量"></el-table-column>
                <el-table-column property="skuName" align="center" show-overflow-tooltip label="规格"
                                 width="200"></el-table-column>
<!--                <el-table-column label="配送方式" align="center">-->
<!--                  <template slot-scope="scope">-->
<!--                    {{ getDelivery(scope.row) }}-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <!-- <el-table-column property="skuName" label="优惠"></el-table-column> -->
                <el-table-column label="总价" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.count * scope.row.sellPrice }}
                  </template>
                </el-table-column>
                <el-table-column property="actualAmount" align="center" label="实付"></el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>

<!--        <el-tab-pane label="订单进度" name="third">-->
<!--          <el-table :data="orderProgressData">-->
<!--            <el-table-column property="orderProgressName" label="进度" width="200"></el-table-column>-->
<!--            <el-table-column property="createTime" label="时间"></el-table-column>-->
<!--          </el-table>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </el-dialog>

<!--    发货-->
    <order-dialog  :courierList="courierList" ref="orderDialog" @getList="getList"></order-dialog>

    <div style="width: 100%">
      <!--  打印小票-->
      <div id="printPage">
        <printBox ref="printOrder" :courierList="courierList" ></printBox>
      </div>

    </div>
  </div>
</template>

<script>
import MapComponent from '@/components/MapComponent/index.vue'
import {mapState} from 'vuex'
import printBox from "@/views/order/components/printBox.vue";
import printJS from 'print-js'
import OrderDialog from "@/views/order/components/orderDialog.vue";


export default {
  components: {OrderDialog, MapComponent, printBox},
  data() {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      ids: [],
      form: {},
      showDialog: false,
      activeName2: null,
      tableData: [],
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      dialogOrderItemVisible: false,
      addressDialog: false,
      btnloading: false,
      loading: false,
      orderInfo: {},
      setaddress: {},
      orderItemData: [],
      activeName: 'first',
      orderProgressData: [],
      kdData: null,
      valuechange: [],
      courierList: [],
      // printOrder: false,
      orderStatusMap: {
        1: '待发货',
        2: '待发货',
        3: '已发货',
        4: '团长待签收',
        5: '待核销',
        6: '团长待配送',
        7: '已完成',
        8: '已评价',
        10: '已取消'
      },
      getTypeMap: {
        1: '团长配送',
        2: '客户自提',
        3: '快递物流'
      },
      OrderType:{
        1: "今日优惠订单",
        2: "新品展示订单",
        3: "爆款专区订单",
        4: "新人专享订单",
        5: "好物推荐订单",
        6: "会员专区订单",
        7: "拼团订单",
        8: "砍价订单",
        9: "秒杀订单"
      }



    }
  },
  filters: {
    orderStatusText(val) {
      if (!val) return '订单状态未知'
      switch (val) {
        case 1:
          return '订单待付款'
        case 2:
          return '订单待发货'
        case 3:
          return '订单待收货'
        case 4:
          return '订单已完成'
        case 5:
          return '订单已取消'
        case 6:
          return '订单已退款'
        case 7:
          return '订单已关闭'
        case 8:
          return '订单已评价'
        default:
          return '订单状态未知'
      }
    }
  },
  computed: {
    searchKeyword: {
      get() {
        return this.$store.state.main.searchKeyword
      },
      set(value) {
        this.$store.commit('main/changeSearchKeyword', value)
      }
    },
    ...mapState('main', [
      'longitude',
      'latitude',
      'provinceCode',
      'provinceName',
      'cityCode',
      'cityName',
      'areaCode',
      'areaName'
    ]),


  },
  /* watch: {
    searchKeyword(val) {
      this.setaddress.expressAddress = val

    }
  }, */
  async created() {
    this.getList()
    this.getKdDetail()
    await this.$store.dispatch('courier/getCourierList')
    console.log(this.$store.state.courier.courierList, 637)
    this.courierList = this.$store.state.courier.courierList
  },

  mounted() {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {

    getOrderType(val){
      if(val){
        return this.OrderType[val]
      }
      return '普通订单'
    },

    goDelivery(row){

      this.$refs.orderDialog.init(row.orderNumber)
    },

    getCourierName(val) {
      console.log(val, 652)
      if (val) {
        return this.courierList.find(item => item.shipperCode === val).shipperName
      } else {
        return "-"
      }

    },

    async printBox(val) {


      await this.$refs.printOrder.init(val)

      document.querySelector('#printPage').style.display = 'block'
      this.$nextTick(() => {
        printJS({
          printable: 'printPage',//打印区域id
          type: 'html',//打印类型
          style: `@page { size: 58mm auto; margin: 0; }`,
          targetStyles: ['*'],
          scanStyle: false,
          font_size: 'llllll'
        })

        //获取打印内容后隐藏dom
        document.querySelector('#printPage').style.display = 'none'
      })

    },


    handleClick2(tab) {
      if (tab.name === '6') {
        sessionStorage.setItem('activePath', '/mallaftersales')

        // window.location.reload()
        this.$router.push('/mallaftersales')
      } else {
        this.queryInfo.condition.viewOrderStatus = tab.name
        this.search()
      }
    },

    handleSelectionChange(val) {
      this.ids = val.map(item => item.id)
    },
    async printOrderList() {

      console.log(this.ids, 643)

      if (this.ids.length === 0) {
        return this.$message.error("请先选择要打印的小票")
      }

      const res = await this.$http.post('order/printOrderList', {ids: this.ids})
      if (res.data.code === 200) {
        this.$message.success("小票打印成功")
      } else {
        this.$message.error(res.data.message)
      }
    },

    search() {
      this.queryInfo.currPage = 1
      this.getList()
    },

    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - this.headerHeight - 256
    },

    change() {
      console.log(this.valuechange)
      if (this.valuechange) {
        this.queryInfo.condition.orderTimeStart = this.valuechange[0]
        this.queryInfo.condition.orderTimeEnd = this.valuechange[1]
      } else {
        this.valuechange = []
        this.queryInfo.condition.orderTimeStart = ''
        this.queryInfo.condition.orderTimeEnd = ''
      }
    },

    // 查询已保存内容
    async getKdDetail() {
      const res = await this.$http.post('kdniaoShipperAccount/queryOne', {})
      console.log(res, '查询结果')
      if (res.data.code == 200 && res.data.data != null) {
        this.kdData = res.data.data
        // this.defaultCompany = this.kdData.defaultCompany
        // this.shipperName = this.kdData.shipperName
        console.log(this.kdData, '--默认快递--')
      }
    },

    async delivery(row) {
      let data = {
        orderNumber: row.orderNumber,
        supplierCode: row.supplierCode,
        shipperCode: this.kdData.shipperCode
      }

      const res = await this.$http.post('kdniaoShipperAccount/createWayBill', data)
      if (res.data.code == 200) {
        this.$message.success("预约成功,请准备好包裹")
        this.getList()
        // await this.$http.post('kdniaoShipperAccount/reservationPickUp', data)
      } else {
        this.$message.error(res.data.message)
      }
    },

    // 获取数据
    getList() {
      var that = this
      that.loading = true
      console.log(that.queryInfo.condition, 649)
      that.$http
        .post('/order/manageList', that.queryInfo)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.loading = false
            that.total = response.data.data.count
            that.queryInfo.currPage = response.data.data.currPage
            that.tableData = response.data.data.data
          }
        })
    },

    // 保存
    handleSave() {
      var that = this
      that.$http
        .post('/order/save', that.form)
        .then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '保存成功',
              showClose: true
            })
            that.showDialog = false
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
        .catch(function (error) {
        })
    },

    // 修改
    edit(row) {
      this.showDialog = true
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },
    openaddress() {
      this.setaddress = JSON.parse(JSON.stringify(this.orderInfo))
      // 地图默认数据
      this.$store.commit('main/changeSearchKeyword', this.setaddress.expAreaDetail)
      this.$store.commit('main/changeLatitudeAndLongitude', {
        latitude: this.setaddress.latitude,
        longitude: this.setaddress.longitude
      })
      this.$store.commit('main/changeProvince', {
        provinceCode: this.setaddress.provinceCode,
        provinceName: this.setaddress.provinceName,
        cityCode: this.setaddress.cityCode,
        cityName: this.setaddress.cityName,
        areaCode: this.setaddress.areaCode,
        areaName: this.setaddress.areaName
      })
      this.addressDialog = true
      this.$refs.selectMap && this.$refs.selectMap.initMap()
    },
    saveaddress() {
      if (this.btnloading) {
        return
      }
      this.btnloading = true
      var that = this
      const _data = {
        // id: this.setaddress.id,
        orderNumber: this.setaddress.orderNumber,
        expAreaDetail: this.provinceName + this.cityName + this.areaName,
        expressAddress: this.setaddress.expressAddress,
        longitude: this.longitude,
        latitude: this.latitude,
        provinceCode: this.provinceCode,
        provinceName: this.provinceName,
        cityCode: this.cityCode,
        cityName: this.cityName,
        expAreaCode: this.areaCode,
        expAreaName: this.areaName
      }
      that.$http
        .post('/order/update', _data)
        .then(response => {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '修改成功',
              showClose: true
            })
            that.addressDialog = false
            that.orderInfo.expAreaDetail = _data.expAreaDetail
            that.orderInfo.expressAddress = _data.expressAddress
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
          that.btnloading = false
        })
        .catch(function (error) {
          that.btnloading = false
        })
    },


    // 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/order/delete', {id: id}).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },

    // 新增按钮
    newBtn() {
      this.labelType = 'add'
      this.showDialog = true
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange(val) {
      this.queryInfo.currPage = val
      this.getList()
    },

    showOrderItemInfo(row) {
      this.orderItemData = row.orderItems
      // console.log("------订单详情----------");
      console.log(row)
      // console.log("------订单详情----------");
      this.orderInfo = JSON.parse(JSON.stringify(row))
      this.dialogOrderItemVisible = true
    },
    getDelivery(row) {
      // 是否门店自提
      if (row.isSelfPickup == 1) {
        return '门店自提'
      }
      // 是否专享配送
      if (row.isSelfPickup == 1) {
        return '专享配送'
      }
      // 是否快递配送
      if (row.isSelfPickup == 1) {
        return '快递配送'
      }
      // 团长配送
      if (row.isSelfPickup == 1) {
        return '团长配送'
      }
    },
    getPayType(patType) {
      if (patType === '1') {
        return '微信'
      } else if (patType === '2') {
        return '支付宝'
      } else if (patType === '3') {
        return '余额'
      } else if (patType === '4') {
        return '储值卡'
      } else if (patType === '1,5') {
        return '微信+积分'
      } else if (patType === '1,3') {
        return '微信+余额'
      } else if (patType === '1,4') {
        return '微信+储值卡'
      } else if (patType === '2,5') {
        return '支付宝+积分'
      } else if (patType === '2,3') {
        return '支付宝+余额'
      } else if (patType === '2,4') {
        return '支付宝+储值卡'
      } else if (patType === '3,5') {
        return '余额+积分'
      } else if (patType === '4,5') {
        return '储值卡+积分'
      } else if (patType === '6') {
        return '企业月付'
      }
    },
    handleClick(tab, event) {
      //   console.log("tab:",tab.name);
      // console.log("event:",event);
      // console.log(tab, event);
      if (tab.name === 'third') {
        this.getOrderProhress()
      }
    },

    /**
     * 获取订单进度
     *
     */
    getOrderProhress() {
      var that = this
      var data = {}
      data.orderNumber = this.orderInfo.orderNumber
      that.$http
        .post('/orderProgress/queryList', data)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.orderProgressData = response.data.data
          }
        })
    },
    reset() {
      this.queryInfo.condition = {}
      this.valuechange = []
      this.getList()
    },

    // 打印订单
    printOrder(row) {

      this.printBox([row])

      // var that = this
      // var data = {}
      // data.id = row.id
      // that.$http
      //   .post('/printer/printPlatformOrder', data)
      //   .then(function (response) {
      //     console.log(response.data.data)
      //     if (response.data.code == 200) {
      //       that.$notify.success({
      //         title: '提示',
      //         message: '打印指令发送成功',
      //         showClose: true
      //       })
      //     }
      //   })
      // }
    },

    exportExcel(){
      var that = this

      console.log(that.queryInfo.condition, 649)
      var data={}
      data.orderTimeStart=  this.queryInfo.condition.orderTimeStart;
      data.orderTimeEnd=  this.queryInfo.condition.orderTimeEnd ;
      if(!data.orderTimeStart){
            that.$notify.info({
              title: '提示',
              message: "请选择时间",
              showClose: true
            })
            return;
      }
      that.$http
        .post('/order/exportExcel', data)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            window.open(response.data.data);
          }
        })
    },
  }
}
</script>

<style lang="less" scoped>
.info_dialog {
  /deep/ .el-dialog__body {
    padding: 5px 40px;
  }

  .info_box {
    width: 100%;
    height: 70vh;
    overflow-y: auto;
  }

  .info_status_box {
    width: 100%;
    padding: 10px 13px;
    box-sizing: border-box;
    background: #f2f9fd;
    border: 2px solid #8ecbeb;
    display: flex;
    flex-direction: column;

    .info_status {
      margin-bottom: 6px;
      color: #409EFF;
    }

    .info_change_btn {
      /deep/ .el-button {
        font-size: 12px;
      }
    }
  }

  .info_section {
    width: 100%;
    padding: 10px 8px;
    box-sizing: border-box;

    .info_section_header {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .info_section_cnt {
      width: 100%;
      padding: 0 3px;
      box-sizing: border-box;

      .el-col {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
      }

      .info_section_span {
        padding-left: 14px;
      }
    }
  }
}
</style>
